<div class="action-arrow__content">
	<a class="action-icon action-icon-active" (click)="onDeleteMapperLender()">
		<i class="fas fa-trash active"></i>
	</a>
	<a class="action-icon action-icon-active" (click)="onEditMapperLender()">
		<i class="fas fa-edit active"></i>
	</a>
</div>
